import { jsx as _jsx } from "react/jsx-runtime";
import { Typography, useTheme } from "@mui/material";
export const DetailTabHeading = (props) => {
    const { itemName } = props;
    const theme = useTheme();
    return (_jsx(Typography, Object.assign({ variant: "h2", align: "left", color: "primary", style: { marginBottom: theme.spacing(2) } }, { children: itemName })));
};
